import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "../components/Reveal";
import { PORTFOLIO } from "../data/site";

export const Portfolio = () => (
  <section id="portfolio" data-testid="portfolio-section" className="relative scroll-mt-24 bg-[#05070D]/65 py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Eyebrow>05 · Portfólio</Eyebrow>
          <h2 className="mt-5 max-w-xl text-3xl font-semibold tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
            Projetos com rigor técnico e foco em resultado
          </h2>
        </div>
        <p className="max-w-xs text-sm leading-relaxed text-slate-500" data-testid="portfolio-note">
          Seleção demonstrativa de formatos e entregas — portfólio de clientes em atualização.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-5 md:grid-cols-3" data-testid="portfolio-grid">
        {PORTFOLIO.map((p, i) => (
          <Reveal key={p.title} delay={0.1 * i}>
            <article
              data-testid={`portfolio-card-${i}`}
              className="group relative overflow-hidden rounded-2xl border border-white/[0.07] bg-[#0B0F14]"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#05070D] via-transparent to-transparent" />
                <span className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-[#05070D]/60 text-slate-200 opacity-0 backdrop-blur-sm transition-[opacity,transform] duration-500 group-hover:opacity-100">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
              <div className="p-7">
                <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-[#3a9bff]">
                  {p.category}
                </p>
                <h3 className="mt-3 text-lg font-semibold leading-snug text-slate-100">
                  {p.title}
                </h3>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
